import { Div } from './Div';
import * as DomUtil from 'leaflet/src/dom/DomUtil';
import log from 'log';

export var Textbox = Div.extend({

    initialize: function (latLngBounds, options, changeFunc) {
        this._pos = latLngBounds;
        Div.prototype.initialize.call(this, latLngBounds, options);

        //        log('Pos: ' + this._pos);
        //        log('Options: ' + options)

        var textBox = DomUtil.create('input', '');
        textBox.type = 'text';

        if(changeFunc != undefined)
            textBox.oninput = changeFunc;

        textBox.style.width = '100%';
        textBox.style.height = '100%';
        textBox.style.margin = '0px';
        textBox.style.position = 'absolute';
        textBox.style.borderWidth = '0px';
        textBox.style.borderRadius = '3px';
        textBox.style.backgroundColor = options.color;
        this._elem = textBox;
    },

    onAdd: function (map) {
        Div.prototype.onAdd.call(this, map);
        this._div.appendChild(this._elem);
    },

    _setPosition: function () {
        Div.prototype._setPosition.call(this);
        this._elem.style.fontSize = this._div.style.height;
    },

    setValue: function(newValue){
        //log("Setting new value to tetxbox: " + newValue);
        this._elem.value = newValue;
    },

    getValue: function(){
        return this._elem.value;
    },

    setFormat : function(format){
        switch(format){
        case 'number':
            //this._elem.type = format;
            this._elem.placeholder = 'Insert a number';
            this._elem.onblur = function(input){
                log(input);
                if(isNaN(input.target.value)){
                    alert('Inserted value must be a valid number');
                    input.target.value = '';
                }

            };
            break;
        case 'date':
            this._elem.type = format;
            break;
        default:
            throw new Error('Format unavailable or not yet implemented.');
        }
    }

});

